<template>
<div class="chapter">
<div class="inner_page">
<div>
<a id="chro"></a>
</div>
<h4 class="fronthead2"><strong>C<span class="sc">HRONOLOGY OF</span> E<span class="sc">VENTS</span></strong></h4>
<p class="textafterfront">September 11, 2001</p>
<table cellpadding="0" cellspacing="0">
<tbody><tr>
<td valign="top">
<p class="noindent"><strong>8:46</strong> <span class="sc">A.M.</span>  </p>
</td>
<td valign="top">
<p class="noindent">American Airlines Flight 11 from Boston, MA, to Los Angeles, CA Flew into the north face—floors 93 to 99—of the North Tower</p>
</td>
</tr>
<tr>
<td valign="top"></td>
<td valign="top">
<p class="noindent">Tower One of the World Trade Center</p>
</td>
</tr>
<tr>
<td valign="top">
<p class="textbreak"><strong>9:03</strong> <span class="sc">A.M.</span>  </p>
</td>
<td valign="top">
<p class="textbreak">United Airlines Flight 175 from Boston, MA, to Los Angeles, CA Flew into the south face—floors 77 to 85—of the South Tower</p>
</td>
</tr>
<tr>
<td valign="top"></td>
<td valign="top">
<p class="noindent">Tower Two of the World Trade Center</p>
</td>
</tr>
<tr>
<td valign="top">
<p class="textbreak"><strong>9:59</strong> <span class="sc">A.M.</span>  </p>
</td>
<td valign="top">
<p class="textbreak">Tower Two Collapses</p>
</td>
</tr>
<tr>
<td valign="top"></td>
<td valign="top">
<p class="noindent">The South Tower of the World Trade Center</p>
</td>
</tr>
<tr>
<td valign="top">
<p class="textbreak"><strong>10:28</strong> <span class="sc">A.M.</span>  </p>
</td>
<td valign="top">
<p class="textbreak">Tower One Collapses</p>
</td>
</tr>
<tr>
<td valign="top"></td>
<td valign="top">
<p class="noindent">The North Tower of the World Trade Center</p>
</td>
</tr>
</tbody></table>
<div class="fifteen">
<p class="noindent"><span class="underline">Note</span></p>
</div>
<p class="noindent">Times are those established by the National Institute of Standards and Technology (NIST)</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 06_chro.vue?0e148f17